export const SIGN_IN_MESSAGES = {
  duplicateEmail: {
    title: 'This email already has a StagePilot sign-in',
    text: 'This email is already used with a different way of signing in. If it is yours, please sign in the way you did the first time (for example with Google, or with your email and password). That keeps all your streams and overlays in one account.',
    anotherWay: 'Sign in another way'
  }
} as const

export const ACCESS_DENIED_ERROR = 'access_denied'
export const DUPLICATE_EMAIL_CODE = 'duplicate_email'

export const isDuplicateEmailRefusal = (error: unknown): boolean => {
  if (error == null || typeof error !== 'object') return false
  const { error: code, message } = error as { error?: unknown, message?: unknown }
  return code === ACCESS_DENIED_ERROR && message === DUPLICATE_EMAIL_CODE
}
